import React, { useEffect, useContext } from 'react';
import AuthContext from '../../context/AuthContext';

const Signoff = () => {

    const { handleCloseSesion } = useContext(AuthContext);

    useEffect(() => {
        handleCloseSesion();
    },[]);

    return (
        <div className="grid">
            Sign off
        </div>
    );
}

export default Signoff;